import React from 'react'
import CommonInput from './CommonInput'
// import { useToggleState } from '@linqpal/common-frontend/src/hooks'

export const Input = ({ value = '', onChangeText, editable = true, ...props }) => {
  // const [focused, onFocus, onBlur] = useToggleState()

  return (
    <CommonInput
      value={value}
      onChangeText={onChangeText}
      editable={editable}
      {...props}
    />
  )
}
